export interface AppointmentBelongingChecklistLike {
  returned: boolean;
}

export type AppointmentBelongingChecklistStatus = "pendente" | "concluido";

export interface AppointmentBelongingChecklistSummary {
  total: number;
  returnedCount: number;
  pendingCount: number;
  status: AppointmentBelongingChecklistStatus;
}

export function summarizeAppointmentBelongingsChecklist(
  items: AppointmentBelongingChecklistLike[],
): AppointmentBelongingChecklistSummary {
  const total = items.length;
  const returnedCount = items.reduce((acc, item) => acc + (item.returned ? 1 : 0), 0);
  const pendingCount = total - returnedCount;

  return {
    total,
    returnedCount,
    pendingCount,
    status: pendingCount > 0 ? "pendente" : "concluido",
  };
}
